import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { Typography, Button, Autocomplete, TextField, Grid, Accordion, AccordionDetails, AccordionSummary,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// ToggleButtonGroup,
// ToggleButton,
// MenuItem,
IconButton } from '@mui/material';
import { Icon, InputWithIcon,
// Note: hided until we develop full implementation of sub meter solution instead of interim
// SelectMenu,
toast, BackdropLoader, CONSTANTS, ExpandedTooltip } from '@livable/saas-react-components';
import BillFrequencyModal from './BillFrequencyModal';
import AllocationMethodModal from './AllocationMethodModal';
import VacantUnitBills from './VacantUnitBills';
import CADModal from './CADModal';
import { ListItem } from './UtilityAccordion/listItem';
import { UtilitiesAutocomplete } from './UtilitiesAutocomplete';
// NOTE: Hidden Auto billing feature until further development
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BillingAutomationSetup } from './BillingAutomationSetup';
import useBillingTemplateModalContentStyles from './styles';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { ALLOCATION_METHOD, BILL_FREQUENCY_NAME, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY, VACANT_UNIT_USAGE, VACANT_UNIT_USAGE_TO_TRANSLATE } from 'src/constants/utilities';
import GLModal from './GLModal';
import { toJS } from 'mobx';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';

/** Backend may send 0.55 (decimal) or 55 (percentage). Returns integer 0–100 for display. */
function formatVacantUnitUsageLimitPercent(value) {
  const n = Number(value !== null && value !== void 0 ? value : 0);
  if (Number.isNaN(n)) return 0;
  return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
}
export const BillingTemplateModalContent = observer(_ref => {
  var _propertyUtility$prov6, _propertyUtility$util5, _store$homeDashboardS15;
  let propertyUtility = _ref.propertyUtility,
    isEditing = _ref.isEditing,
    handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles({
    modalHasNoMargin: true,
    modalHasNoPadding: true
  });
  const classes = useBillingTemplateModalContentStyles();

  // Note: hided until we develop full implementation of sub meter solution instead of interim
  // const [unitOfMeasure, setUnitOfMeasure] = useState('gal');

  // const handleUnitOfMeasureChange = event => {
  //   if (event.target.value) setUnitOfMeasure(event.target.value);
  // };
  const _useState = useState('RUBS'),
    _useState2 = _slicedToArray(_useState, 2),
    billingMethodType = _useState2[0],
    setBillingMethodType = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchResultItems = _useState6[0],
    setSearchResultItems = _useState6[1];
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.trim().length > 0) {
      if (searchUtilityProvidersHandler) {
        setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems([{
          id: 'createCustomProviderId',
          key: 'createCustomProviderKey',
          label: value + ' (add new provider)',
          inputName: value
        }, ...resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            id: item.key,
            key: item.key,
            label: item.value
          });
        })]);
      }), 350);
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([{
      id: 'createCustomProviderId',
      key: 'createCustomProviderKey',
      label: value + ' (add new provider)',
      inputName: value
    }]);
  };
  const _useState7 = useState(propertyUtility.provider.isCustom || false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCustomProviderMode = _useState8[0],
    setIsCustomProviderMode = _useState8[1];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [customProviderName, setCustomProviderName] = useState(propertyUtility.provider.utilityProviderName || '');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [customProviderWebsite, setCustomProviderWebsite] = useState(propertyUtility.provider.website || '');

  const GetBillingSettingsList = observer(() => {
    var _store$homeDashboardS, _store$homeDashboardS2, _propertyUtility$util, _store$homeDashboardS3, _store$homeDashboardS4, _propertyUtility$util2, _store$homeDashboardS5, _propertyUtility$util3, _store$homeDashboardS6, _propertyUtility$util4;
    const list = [
    // NOTE: Hidden Auto billing feature until further development
    // {
    //   title: t('add_new_property_flow.auto_billing'),
    //   id: `UtilityAccordion_auto_billing_id`,
    //   key: `UtilityAccordion_auto_billing_key_${propertyUtility?.provider?.isAppAutomationEnabled}`,
    //   value: 'inactive',
    //   iconType: 'paper-dollar',
    //   isActive: propertyUtility?.provider?.isAppAutomationEnabled,
    //   action: (
    //     <BillingAutomationSetup
    //       customTrigger={
    //         <Button
    //           variant="actionButton"
    //           size="small"
    //           disabled={!propertyUtility?.provider?.isAppAutomationEnabled}
    //         >
    //           {t('add_new_property_flow.begin_activation')}
    //         </Button>
    //       }
    //       isEdit={isEditing}
    //       billingTemplate={propertyUtility}
    //     />
    //   ),
    // },
    {
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_id",
      key: "UtilityAccordion_bill_frequency_key_".concat(propertyUtility.billFrequencyType),
      value: BILL_FREQUENCY_NAME[propertyUtility.billFrequencyType],
      isActive: true,
      isDefault: true,
      action: /*#__PURE__*/React.createElement(BillFrequencyModal, {
        propertyUtility: propertyUtility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_allocation_method_id",
      key: "UtilityAccordion_allocation_method_key_".concat(propertyUtility.allocationMethod),
      value: CONSTANTS.ALLOCATION_METHODS[propertyUtility.allocationMethod] + "".concat((propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.propertyBuildingSquare) === 0 ? ' (Error: Property Sq. footage not defined!)' : ''),
      isDefault: ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util === void 0 ? void 0 : _propertyUtility$util.utilityTypeId)) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.defaultAllocationMethod) === propertyUtility.allocationMethod,
      isActive: true,
      isError: (propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.propertyBuildingSquare) === 0,
      action: /*#__PURE__*/React.createElement(AllocationMethodModal, {
        propertyUtility: propertyUtility,
        billingMethod: billingMethodType,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_id",
      key: "UtilityAccordion_handling_vacant_unit_key_".concat(propertyUtility.vacantUnitUsage),
      value: "".concat(t(VACANT_UNIT_USAGE_TO_TRANSLATE[propertyUtility.vacantUnitUsage])).concat(propertyUtility.vacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? " (".concat(formatVacantUnitUsageLimitPercent(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.vacantUnitUsageLimit), "%)") : ''),
      isDefault: ((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util2 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util2 === void 0 ? void 0 : _propertyUtility$util2.utilityTypeId)) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.defaultVacantUnitUsage) === propertyUtility.vacantUnitUsage,
      isActive: true,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        propertyUtility: propertyUtility,
        isEdit: isEditing
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_id",
      key: "UtilityAccordion_common_area_deduction_key_".concat(propertyUtility.commonAreaDeduction),
      isDefault: (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS5 !== void 0 && (_store$homeDashboardS5 = _store$homeDashboardS5.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util3 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util3 === void 0 ? void 0 : _propertyUtility$util3.utilityTypeId)) !== null && _store$homeDashboardS5 !== void 0 && _store$homeDashboardS5.cad ? propertyUtility.commonAreaDeduction === 5 : propertyUtility.commonAreaDeduction === 0,
      isActive: true,
      value: propertyUtility.commonAreaDeduction + '%',
      // isError: true, // NOTE: TBD if needed
      // customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        propertyUtility: propertyUtility,
        isEdit: isEditing,
        goodWillDeductionValue: propertyUtility.goodWillDeduction,
        defaultCadEnabled: (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$util4 = propertyUtility.utilityTypes[0]) === null || _propertyUtility$util4 === void 0 ? void 0 : _propertyUtility$util4.utilityTypeId)) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.cad
      })
    }, {
      title: t('general.goodwill_deduction'),
      id: "UtilityAccordion_good_will_deduction_id",
      key: "UtilityAccordion_good_will_deduction_key",
      value: propertyUtility.goodWillDeduction,
      isDefault: propertyUtility.goodWillDeduction === 5,
      utilityCAD: propertyUtility.commonAreaDeduction,
      onChangeCallback: val => propertyUtility.setGoodWillDeduction(Number(val)),
      submitCallback: () => {
        // console.log('itemSubmitCallback');
      },
      isGWD: true,
      isActive: true,
      isEditable: !isEditing,
      showInfo: isEditing,
      infoComponent: /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "info",
        title: t('add_new_property_flow.update_gwd_info'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        state: "info",
        type: "question"
      })))
    }];
    if (billingMethodType !== 'RUBS') {
      list.unshift({
        title: t('Property meter ID'),
        id: "UtilityAccordion_property_meter_id",
        key: "UtilityAccordion_property_meter_key_",
        value: 'Not provided',
        warningValue: true,
        isActive: false,
        action: /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          size: "small",
          disabled: true,
          'custom-attribute': '615-new-billing-module'
        }, t('Provide ID'))
      }, {
        title: t('Unit meter IDs'),
        id: "UtilityAccordion_unit_meter_id",
        key: "UtilityAccordion_unit_meter_key_",
        value: '0/10 provided',
        warningValue: true,
        isActive: false,
        action: /*#__PURE__*/React.createElement(Button, {
          variant: "contained",
          size: "small",
          disabled: true,
          'custom-attribute': '616-new-billing-module'
        }, t('Provide ID'))
      }, {
        title: t('Charge variance alert'),
        id: "UtilityAccordion_charge_variance_alert_id",
        key: "UtilityAccordion_charge_variance_alert_key_",
        value: '20%',
        isActive: true,
        isEditable: true
      });
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      var _store$homeDashboardS7, _store$homeDashboardS8, _store$homeDashboardS9;
      const defaultGl = (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.details) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.glCodeSetup) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.glAccountExternalId;
      const customGl = (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.details) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.glCodeSetup) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.utilityGlAccounts) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.find(ci => ci.propertyUtilityLivableId === (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId))) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.glAccountExternalId;
      list.push({
        title: t('GL account'),
        id: "UtilityAccordion_gl_id",
        key: "UtilityAccordion_gl_key_".concat(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId),
        isDefault: !customGl || defaultGl === customGl,
        isActive: true,
        value: (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.details) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.glCodeSetup.getGlNameByCode(customGl ? customGl : defaultGl),
        action: /*#__PURE__*/React.createElement(GLModal, {
          propertyUtility: propertyUtility,
          savedValue: customGl ? customGl : defaultGl,
          onSaveAndClose: async glId => {
            var _store$homeDashboardS0;
            (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.details) === null || _store$homeDashboardS0 === void 0 || _store$homeDashboardS0.glCodeSetup.updateUtilityGlAccounts(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.propertyUtilityId, glId);
          },
          isEdit: isEditing
        })
      });
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEditing ? "List_ITEM_NEW_".concat(item.key) : "List_ITEM_".concat(item.key),
      item: item
    }));
  });
  const _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    newSelectedProviderData = _useState0[0],
    setNewSelectedProviderData = _useState0[1];
  const configureBillingTemplateBySelectedProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && (value === null || value === void 0 ? void 0 : value.id) === 'createCustomProviderId') {
      // toggle custom provider create
      setIsCustomProviderMode(true);
      // setCustomProviderName(value.inputName);
      if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
        propertyUtility.configureProviderModelForNewTemplate({
          name: value.inputName,
          isCustom: true,
          utilities: null
        });
        propertyUtility.removeUtilityType('all');
      }
      return;
    }
    if (value && (value !== null && value !== void 0 && value.id || value !== null && value !== void 0 && value.utilityProviderId)) {
      await Promise.all([store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id || value.utilityProviderId]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          setNewSelectedProviderData(_objectSpread({}, singleElementOfArray(resp.response)));
          propertyUtility.configureProviderModelForNewTemplate(singleElementOfArray(resp.response));
          if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
            propertyUtility.removeUtilityType('all');
          }
        }
      })]);
    }
  };
  const createUpdateCustomUtilityTemplate = async () => {
    const createEditCustomProvider = async _ref2 => {
      let isEditProvider = _ref2.isEditProvider,
        name = _ref2.name,
        website = _ref2.website,
        providerId = _ref2.providerId,
        genericUtilityTypesToAssign = _ref2.genericUtilityTypesToAssign;
      if (isEditProvider) {
        await store.utilityProviders.editCustomUtilityProvidersAsync.run({
          name,
          website,
          providerId,
          propertyId: store.homeDashboardStore.getCurrentProperty.id
        }, [propertyUtility.propertyUtilityId]);
        return providerId;
      } else {
        const _await$store$utilityP = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
            name,
            website,
            propertyId: store.homeDashboardStore.getCurrentProperty.id,
            utilityTypeIds: genericUtilityTypesToAssign
          }, [propertyUtility.propertyUtilityId]),
          createdProviderId = _await$store$utilityP.response,
          isSuccessful = _await$store$utilityP.isSuccessful;
        if (isSuccessful) {
          return createdProviderId;
        }
      }
    };
    const createCustomUtilitiesAndApplyToProvider = async _ref3 => {
      let utilityName = _ref3.utilityName,
        allocationMethod = _ref3.allocationMethod,
        vacantUnitUsage = _ref3.vacantUnitUsage,
        vacantUnitAllocation = _ref3.vacantUnitAllocation,
        commonAreaDeduction = _ref3.commonAreaDeduction,
        providerIdToAttach = _ref3.providerIdToAttach;
      return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
        name: utilityName,
        defaultAllocationMethod: allocationMethod,
        defaultVacantUnitUsage: vacantUnitUsage,
        paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[vacantUnitAllocation],
        cad: !!commonAreaDeduction,
        utilityProviderId: providerIdToAttach
      }, [propertyUtility.propertyUtilityId]);
    };
    let customProviderId;
    if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
      customProviderId = await createEditCustomProvider({
        isEditProvider: false,
        name: propertyUtility.provider.utilityProviderName,
        website: propertyUtility.provider.website,
        providerId: undefined,
        genericUtilityTypesToAssign: propertyUtility.provider.utilities.map(i => i.utilityTypeId)
      });
      propertyUtility.provider.setUtilityProviderId(customProviderId);
      for (let customUt of propertyUtility.utilityTypes.filter(i => i === null || i === void 0 ? void 0 : i.utilityTypeId.startsWith('customUtilityId_'))) {
        const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
          utilityName: customUt.utilityTypeName,
          allocationMethod: propertyUtility.allocationMethod,
          vacantUnitUsage: propertyUtility.vacantUnitUsage,
          vacantUnitAllocation: propertyUtility.vacantUnitAllocation,
          commonAreaDeduction: propertyUtility.commonAreaDeduction,
          providerIdToAttach: customProviderId
        });
        if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
          propertyUtility.updateUtilityTypeIdForNewCustomUtilityType({
            searchUtilityTypeId: customUt.utilityTypeId,
            utilityTypeId: createdCustomUtilitiesResp.response.utilityTypeId
          });
        }
      }
    } else {
      var _propertyUtility$prov;
      await createEditCustomProvider({
        isEditProvider: true,
        name: propertyUtility.provider.utilityProviderName,
        website: propertyUtility.provider.website,
        providerId: (_propertyUtility$prov = propertyUtility.provider) === null || _propertyUtility$prov === void 0 ? void 0 : _propertyUtility$prov.utilityProviderId
      });
      for (let customUt of propertyUtility.utilityTypes.filter(i => i === null || i === void 0 ? void 0 : i.utilityTypeId.startsWith('customUtilityId_'))) {
        var _propertyUtility$prov2;
        const createdCustomUtilitiesResp = await createCustomUtilitiesAndApplyToProvider({
          utilityName: customUt.utilityTypeName,
          allocationMethod: propertyUtility.allocationMethod,
          vacantUnitUsage: propertyUtility.vacantUnitUsage,
          vacantUnitAllocation: propertyUtility.vacantUnitAllocation,
          commonAreaDeduction: propertyUtility.commonAreaDeduction,
          providerIdToAttach: (_propertyUtility$prov2 = propertyUtility.provider) === null || _propertyUtility$prov2 === void 0 ? void 0 : _propertyUtility$prov2.utilityProviderId
        });
        if (createdCustomUtilitiesResp !== null && createdCustomUtilitiesResp !== void 0 && createdCustomUtilitiesResp.isSuccessful) {
          propertyUtility.updateUtilityTypeIdForNewCustomUtilityType({
            searchUtilityTypeId: customUt.utilityTypeId,
            utilityTypeId: createdCustomUtilitiesResp.response.utilityTypeId
          });
        }
      }
    }
    return {
      customProviderId
    };
  };
  const finalizeSavingAndFetchUpdates = unicIdsForReq => {
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchBillingTemplates({
      forceUpdate: true,
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
    store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails().details.fetchPropertyUtilityProviders({
      useUnicInProgress: false,
      customUnicInProgress: unicIdsForReq
    });
  };
  const updateUtilityGlCodes = async () => {
    var _store$homeDashboardS1;
    const glCodeSetup = (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS1 === void 0 || (_store$homeDashboardS1 = _store$homeDashboardS1.details) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.glCodeSetup;
    if (!glCodeSetup || glCodeSetup.utilityGlAccountsPatchSemanticallyEqual()) {
      return;
    }
    let patchValue = glCodeSetup.getUtilityGlAccountsValueForPatch();
    if (!patchValue.length) {
      patchValue = toJS(glCodeSetup.utilityGlAccounts);
    }
    if (!patchValue.length) {
      return;
    }
    await store.credentials.patchAppfolioPropertiesAsync.run({
      properties: [{
        propertyLivableId: store.homeDashboardStore.getCurrentProperty.id,
        utilityGlAccounts: {
          value: patchValue
        }
      }]
    });
    glCodeSetup.handleUtilityGlAccountsSave();
  };
  const createUpdateUtilityTemplate = async () => {
    if (propertyUtility.propertyUtilityId === 'NEW_TEMPLATE') {
      var _store$homeDashboardS10, _propertyUtility$prov3, _store$homeDashboardS12, _propertyUtility$prov5, _store$homeDashboardS13;
      // NOTE: Adding
      if (((_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.selectedPropertyDetails()) === null || _store$homeDashboardS10 === void 0 || (_store$homeDashboardS10 = _store$homeDashboardS10.details) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.getPropertyUtilityProvider((_propertyUtility$prov3 = propertyUtility.provider) === null || _propertyUtility$prov3 === void 0 ? void 0 : _propertyUtility$prov3.utilityProviderId)) === null) {
        var _store$homeDashboardS11, _propertyUtility$prov4;
        const addPropertyUtilityProviderAsyncResp = await store.properties.addPropertyUtilityProviderAsync.run({
          propertyId: (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS11 === void 0 ? void 0 : _store$homeDashboardS11.id,
          utilityProviderId: (_propertyUtility$prov4 = propertyUtility.provider) === null || _propertyUtility$prov4 === void 0 ? void 0 : _propertyUtility$prov4.utilityProviderId
        }, [propertyUtility.propertyUtilityId]);
        if (addPropertyUtilityProviderAsyncResp !== null && addPropertyUtilityProviderAsyncResp !== void 0 && addPropertyUtilityProviderAsyncResp.isSuccessful) {
          console.log('addPropertyUtilityProviderAsyncResp', addPropertyUtilityProviderAsyncResp.response);
        }
      }
      store.propertyUtility.createPropertyUtilitiesAsync.run({
        propertyId: (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.id,
        propertyUtilities: [_objectSpread(_objectSpread({}, propertyUtility), {}, {
          utilityProviderId: (_propertyUtility$prov5 = propertyUtility.provider) === null || _propertyUtility$prov5 === void 0 ? void 0 : _propertyUtility$prov5.utilityProviderId,
          buildingIds: [(_store$homeDashboardS13 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS13 === void 0 ? void 0 : _store$homeDashboardS13.propertyBuildingId],
          utilityTypeIds: propertyUtility.utilityTypes.map(i => i.utilityTypeId),
          vacantUnitUsageLimit: propertyUtility.vacantUnitUsageLimit / 100,
          customCommonAreaDeduction: propertyUtility.commonAreaDeduction
        })]
      }, [propertyUtility.propertyUtilityId]).then(async () => {
        await updateUtilityGlCodes();
        toast('success', {
          body: ['Billing template added!']
        });
        finalizeSavingAndFetchUpdates([propertyUtility.propertyUtilityId]);
      });
    } else {
      var _store$homeDashboardS14;
      // NOTE: Editing
      store.propertyUtility.updatePropertyUtilitiesAsync.run([_objectSpread(_objectSpread({}, propertyUtility), {}, {
        buildingIds: [(_store$homeDashboardS14 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.propertyBuildingId],
        utilityTypeIds: propertyUtility.utilityTypes.map(i => i.utilityTypeId),
        vacantUnitUsageLimit: propertyUtility.vacantUnitUsageLimit / 100,
        customCommonAreaDeduction: propertyUtility.commonAreaDeduction
      })], [propertyUtility.propertyUtilityId]).then(async () => {
        await updateUtilityGlCodes();
        toast('success', {
          body: ['Billing template updated!']
        });
        finalizeSavingAndFetchUpdates([propertyUtility.propertyUtilityId]);
      });
    }
  };

  // Note: hided until we develop full implementation of sub meter solution instead of interim
  // const handleChangeMethodType = (event, value) => {
  //   event.preventDefault();
  //   if (value === 'SubMeter') {
  //     propertyUtility.setAllocationMethod(ALLOCATION_METHOD.BySubmeter);
  //   }
  //   setBillingMethodType(value);
  // };

  const handleTemplateSave = () => {
    if (isCustomProviderMode) {
      createUpdateCustomUtilityTemplate().then(() => {
        createUpdateUtilityTemplate();
      });
    } else {
      createUpdateUtilityTemplate();
    }
    handleClose();
  };
  const getModalIsLoading = () => {
    var _store$properties$add, _store$propertyUtilit, _store$propertyUtilit2;
    return ((_store$properties$add = store.properties.addPropertyUtilityProviderAsync) === null || _store$properties$add === void 0 || (_store$properties$add = _store$properties$add.inProgressUnicIds) === null || _store$properties$add === void 0 ? void 0 : _store$properties$add.includes(propertyUtility.propertyUtilityId)) || ((_store$propertyUtilit = store.propertyUtility.createPropertyUtilitiesAsync) === null || _store$propertyUtilit === void 0 || (_store$propertyUtilit = _store$propertyUtilit.inProgressUnicIds) === null || _store$propertyUtilit === void 0 ? void 0 : _store$propertyUtilit.includes(propertyUtility.propertyUtilityId)) || ((_store$propertyUtilit2 = store.propertyUtility.updatePropertyUtilitiesAsync) === null || _store$propertyUtilit2 === void 0 || (_store$propertyUtilit2 = _store$propertyUtilit2.inProgressUnicIds) === null || _store$propertyUtilit2 === void 0 ? void 0 : _store$propertyUtilit2.includes(propertyUtility.propertyUtilityId));
  };
  useEffect(() => {
    if (propertyUtility.allocationMethod === ALLOCATION_METHOD.BySubmeter) {
      setBillingMethodType('SubMeter');
    }
  }, [propertyUtility]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_the_provider') : t('add_new_property_flow.provider')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, !isEditing && !isCustomProviderMode ? t('add_new_property_flow.find_a_provider_of_the_utilities_that_are_mentioned_in_your_bill') : t('add_new_property_flow.provider_description')), !isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    autoFocus: true,
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    disabled: isEditing,
    clearIcon: true,
    popupIcon: null,
    value: propertyUtility.provider.utilityProviderName || (newSelectedProviderData === null || newSelectedProviderData === void 0 ? void 0 : newSelectedProviderData.name),
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureBillingTemplateBySelectedProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      autoFocus: true
    }, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), isCustomProviderMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: propertyUtility.provider.utilityProviderName,
    onChange: e => {
      propertyUtility.provider.setUtilityProviderName(e.target.value);
    },
    error: !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length,
    helperText: !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length && getRequiredTextMessage('Provide Name')
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: propertyUtility.provider.website,
    onChange: e => {
      propertyUtility.provider.setWebsite(e.target.value);
    }
  })))), (!!newSelectedProviderData || isCustomProviderMode || propertyUtility.propertyUtilityId !== 'NEW_TEMPLATE' || propertyUtility.propertyUtilityId === 'NEW_TEMPLATE' && ((_propertyUtility$prov6 = propertyUtility.provider) === null || _propertyUtility$prov6 === void 0 || (_propertyUtility$prov6 = _propertyUtility$prov6.utilities) === null || _propertyUtility$prov6 === void 0 ? void 0 : _propertyUtility$prov6.length)) && /*#__PURE__*/React.createElement(UtilitiesAutocomplete, {
    key: 'SelectedUtilitiesAutocompleteKey',
    id: 'SelectedUtilitiesAutocompleteId',
    propertyUtility: propertyUtility,
    currentProviderDataExt: newSelectedProviderData,
    isCustomProviderMode: isCustomProviderMode
  }), ((propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityTypes) && !!(propertyUtility !== null && propertyUtility !== void 0 && propertyUtility.utilityTypes.length) || propertyUtility.propertyUtilityId === 'NEW_TEMPLATE' && (propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityTypes) && !!(propertyUtility !== null && propertyUtility !== void 0 && propertyUtility.utilityTypes.length)) && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.billing_settings')), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    id: "utility-content",
    "aria-controls": "utility-content",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContentTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.default_settings'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionContentIcon, " ").concat(isOpen ? 'open' : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "arrow-line-down"
  })))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, /*#__PURE__*/React.createElement(GetBillingSettingsList, null))))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    disabled: getModalIsLoading(),
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleClose();
    },
    'custom-attribute': '617-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: getModalIsLoading() || !(propertyUtility !== null && propertyUtility !== void 0 && (_propertyUtility$util5 = propertyUtility.utilityTypes) !== null && _propertyUtility$util5 !== void 0 && _propertyUtility$util5.length) || (propertyUtility.allocationMethod === ALLOCATION_METHOD.BySquareFootage || propertyUtility.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && Number((_store$homeDashboardS15 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS15 === void 0 ? void 0 : _store$homeDashboardS15.propertyBuildingSquare) === 0 || isCustomProviderMode && !propertyUtility.provider.utilityProviderName && !propertyUtility.provider.utilityProviderName.length,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleTemplateSave();
    },
    'custom-attribute': '618-new-billing-module'
  }, t('Save utility')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getModalIsLoading()
  }));
});